export default __webpack_public_path__ + "static/media/icon_polearm.e5f4a2a1.png";